/* eslint-disable */

import { RootState } from '../types';
import { deserializeReduxState, serializeReduxState, PersistedReduxState } from '.';

export const loadReduxStateFromLS = (): PersistedReduxState | undefined => {
    try {
        const serializedState = localStorage.getItem('state');
        if(!!serializedState) {
            return deserializeReduxState(serializedState);
        }
        return undefined;
    } catch (err) {
        console.log(err);
        return undefined;
    }
};
  
export const saveReduxStateInLS = (state: RootState) => {
    try {
        const serializedState = serializeReduxState(state);
        localStorage.setItem('state', serializedState);
    } catch (err) {
        console.log(err);
        // Ignore write errors.
    }
};